<template lang="pug">
  .search-results
    h1.h5 Search Results
    search-form(
      input-placeholder="What are you looking for?"
    )
    search-results-tabs(v-on:change-tab="changeTab")
    search-results-grid(
      :search-results="getFilteredResults"
      :current-tab="currentTab"
      :search-term="term"
      :search-cta-settings="searchCtaSettings"
    )
</template>

<script>
import { mapState } from 'vuex'
import SearchResultsTabs from './SearchResultsTabs.vue'
import SearchResultsGrid from './SearchResultsGrid.vue'
import SearchForm from './SearchForm.vue'

export default {
  name: 'SearchResults',
  components: { SearchForm, SearchResultsTabs, SearchResultsGrid },
  props: {
    searchResults: {
      type: Object,
      default: () => ({
        products: Array,
        blog: Array,
        pages: Array
      })
    },
    term: String,
    searchPerformed: Boolean,
    searchCtaSettings: Object
  },
  

  computed: {
    
    getFilteredResults() {
        if (window.bvaccel.b2b) {
          const wholesaleProducts = { ...this.searchResults };
          wholesaleProducts.products = wholesaleProducts.products.filter(p => p.tags.includes('wholesale'));
          return wholesaleProducts;
        } else {
          const wholesaleProducts = { ...this.searchResults };
          wholesaleProducts.products = wholesaleProducts.products.filter(p => !p.tags.includes('wholesale'));
          return wholesaleProducts;
        }
    }

  },
  data () {
    return {
      currentTab: 'products'
    }
  },
  methods: {
    changeTab (tab) {
      this.currentTab = tab
    }
  }
}
</script>

<style lang="scss">
  body.template-search {
    #shopify-section-footer-value-props {
      display: none;
    }
  }

  .search-results {
    h1 {
      text-align: center;
      margin-top: 80px;
      margin-bottom: 32px;
    }
    .search-results-tabs {
      margin-top: 64px;
    }
    .search-form {
      display: block;
      margin-left: auto;
      margin-right: auto;
      position: relative;
      max-width: 680px;

      .search-input {
        padding-left: 16px;
        padding-right: 16px;
      }
    }
  }
</style>